import moment from "moment";
import { maskMoeda } from "../../../util/masks";
export const COLUMNS = [
  {
    Header: "Campanha",
    accessor: "campanha",
  },
  {
    Header: "Empresa",
    accessor: "empresa",
  },
  {
    Header: "Tipo Pagamento",
    accessor: "tipoRegra",
  },
  {
    Header: "Sistema",
    accessor: "sistema",
  },
  {
    Header: "Prêmio $",
    accessor: "valor",
    Cell: ({ value }) => `R$ ${maskMoeda(value.toFixed(2))}`,
    sortType: "basic",
  },
  {
    Header: "Usuário Aceite",
    accessor: "usuarioAceite",
  },
  {
    Header: "Data Aceite",
    accessor: "dataAceito",
    Cell: ({ value }) => {
      return moment(value).format("DD/MM/YYYY");
    },
    sortType: "datetime",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Data Conferência",
    accessor: "dataAprovacao",
    Cell: ({ value }) => (value ? moment(value).format("DD/MM/YYYY") : ""),
    sortType: (rowA, rowB, columnId) => {
      const a = rowA.values[columnId]
        ? new Date(rowA.values[columnId])
        : new Date(0);
      const b = rowB.values[columnId]
        ? new Date(rowB.values[columnId])
        : new Date(0);
      return a - b;
    },
  },

  {
    Header: "Usuário Conferência",
    accessor: "usuarioAprovador",
  },
];

export const COLUMNS_DETALHAMENTO = [
  {
    Header: "Campanha",
    accessor: "campanha",
  },
  {
    Header: "Favorecido",
    accessor: "favorecido",
  },
  {
    Header: "Hierarquia",
    accessor: "hierarquia",
  },
  {
    Header: "Status favorecido",
    accessor: "status",
  },
  {
    Header: "Empresa",
    accessor: "empresa",
  },
  {
    Header: "Tipo pagamento",
    accessor: "tipoRegra",
  },
  {
    Header: "Sistema",
    accessor: "sistema",
  },
  {
    Header: "Total pago $",
    accessor: "valor",
  },
];
